import Component from '../core/Component'

export const STATES = {
    SENT: 'is-sent'
}
export const EMITS = {}

export default class EventForm extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            durationDatepicker: null,
            durationMoreInfo: null,
            durationDaypart: null,
            accomodationCheckbox: null,
            accomodationContainer: null
        }
    }

    prepare() {
        if (this.is(STATES.SENT)) {
            return
        }

        this.durationDatepicker = Component.getFromElement(this.ref.durationDatepicker)
        if (!this.durationDatepicker) {
            console.log('duration datepicker missing')
            return
        }

        this.element.addEventListener('change', this.handleChange)

        setTimeout(() => {
            this.check()
        }, 0);
    }

    handleChange = () => {
        this.check()
    }

    check() {
        this.checkDuration()
        this.checkAccomodation()
    }

    checkDuration() {
        const {dateFrom, dateTo} = this.durationDatepicker.getDates()

        if (!(dateFrom && dateTo)) {
            this.ref.durationMoreInfo.style.display = 'none'
        } else {
            this.ref.durationMoreInfo.style.display = ''
        }

        if (dateFrom?.toISOString().split('T')[0] !== dateTo?.toISOString().split('T')[0]) {
            this.ref.durationDaypart.style.display = 'none'
        } else {
            this.ref.durationDaypart.style.display = ''
        }

    }

    checkAccomodation() {
        const checkboxEl = this.element.querySelector('[name="accommodation"]')

        if (!checkboxEl.checked) {
            this.ref.accomodationContainer.style.display = 'none'
        } else {
            this.ref.accomodationContainer.style.display = ''
        }
    }
}